const hostname = window.location.hostname;
const origin = window.location.origin;
const protocol = window.location.protocol;

const BASE_CONFIG = {
  // ENVIRONMENT: ENVIRONMENT,
  GA_KEY: process.env.REACT_APP_GA_KEY,
  API_BASE_URL: "",
  SOCKET_URL: "",
};
// https://custmerchatqa.policybazaar.com
if (hostname === "localhost") {
  BASE_CONFIG["API_BASE_URL"] = "http://localhost:8080/api";
  BASE_CONFIG["SOCKET_URL"] = "ws://localhost:9001/wsServer/connect";
  // BASE_CONFIG["API_BASE_URL"] = "https://customerchatqa.policybazaar.com/api";
  // BASE_CONFIG["SOCKET_URL"] = "wss://customerchatqa.policybazaar.com/wsServer/connect";

  // BASE_CONFIG["GA_KEY"] = "GTM-FFGR"
}else if (hostname === "chatv2.policybazaar.com"){
  BASE_CONFIG["API_BASE_URL"] = `${origin}/api`;
  BASE_CONFIG["SOCKET_URL"] = `ws://${hostname}/wsServer/connect`;
 } else {
  BASE_CONFIG["API_BASE_URL"] = `${origin}/api`;
  BASE_CONFIG["SOCKET_URL"] = `ws://${hostname}/wsServer/connect`;
  // BASE_CONFIG["GA_KEY"] = "GTM-FFGR"
   BASE_CONFIG["GA_KEY"] = "GTM-PW5K"
  if (protocol === "https:") {
    BASE_CONFIG["SOCKET_URL"] = `wss://${hostname}/wsServer/connect`;
  }
  if (hostname === "customerchat.policybazaar.com") {
    BASE_CONFIG["GA_KEY"] = "GTM-PW5K"
  }

}
// console.log(BASE_CONFIG)

export default BASE_CONFIG;
